<template>
  <div class="mortgage-guidance-type-button" :class="{ 'selected': selected }" @click="onSelect">
    <div class="content-container padding-horizontal-ml padding-vertical-m">
      <div class="header-row">
        <div class="main-text">{{ mainText }}</div>
        <div class="price">{{ price }} ₪</div>
      </div>
      <div class="description ri-body">{{ description }}</div>
    </div>
  </div>
</template>

<script>
import Segment from '@/Segment';

export default {
  name: 'MortgageGuidanceTypeButton',
  props: {
    guidanceType: {
      type: String,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
    mainText: {
      type: String,
      required: true,
    },
    price: {
      type: [String, Number],
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  methods: {
    onSelect() {
      Segment.trackUserInteraction('MortgageGuidanceTypeButton_Selected', { guidanceType: this.guidanceType });
      this.$emit('guidance-type-selected', { guidanceType: this.guidanceType });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.mortgage-guidance-type-button {
  cursor: pointer;
  background-color: $riseup_white;
  border-radius: 12px;
  border: unset;
  outline: 2px solid $riseup_gray_10;

  &.selected {
    outline: 2px solid $riseup_blue;
  }

  .content-container {
    display: flex;
    flex-direction: column;
    text-align: right;

    .header-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;

      .main-text {
        font-size: 20px;
        font-weight: bold;
        color: $riseup_black;
      }

      .price {
        font-size: 20px;
        font-weight: bold;
        color: $riseup_black;
      }
    }

    .description {
      color: $riseup_blue;
      font-size: 14px;
      line-height: 1.5;
      white-space: pre-line;
    }
  }
}
</style>
